import { INewbuildingBrokerCallbackWidget } from 'shared/types/newbuildingBrokerCallbackWidget';
import { actionGenerator } from 'shared/utils/redux';

export enum ENewbuildingBrokerCallbackWidgetActionTypes {
  OpenWidget = 'newbuildingBrokerCallbackWidget/openWidget',
  ResetOpeningTrigger = 'newbuildingBrokerCallbackWidget/resetOpeningTrigger',
}

export const openNewbuildingBrokerCallbackWidget = actionGenerator<
  ENewbuildingBrokerCallbackWidgetActionTypes.OpenWidget,
  INewbuildingBrokerCallbackWidget['offerInfo']
>(ENewbuildingBrokerCallbackWidgetActionTypes.OpenWidget);

export const resetOpeningTrigger = actionGenerator<
  ENewbuildingBrokerCallbackWidgetActionTypes.ResetOpeningTrigger,
  void
>(ENewbuildingBrokerCallbackWidgetActionTypes.ResetOpeningTrigger);

export type TNewbuildingBrokerCallbackWidgetActions =
  | ReturnType<typeof openNewbuildingBrokerCallbackWidget>
  | ReturnType<typeof resetOpeningTrigger>;
